import React, { useCallback } from "react";
import { MessageBar } from "@fluentui/react";
export var PanelFooterMessage = React.memo(function (_a) {
    var index = _a.index, onDismiss = _a.onDismiss, message = _a.message, type = _a.type;
    var handleDismiss = useCallback(function () {
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss(index);
    }, [index, onDismiss]);
    return (React.createElement(MessageBar, { messageBarType: type, isMultiline: false, onDismiss: handleDismiss, dismissButtonAriaLabel: "Close" }, message));
});
